import { render, staticRenderFns } from "./OtherContacts.vue?vue&type=template&id=035d05f9&scoped=true"
import script from "./OtherContacts.vue?vue&type=script&lang=ts"
export * from "./OtherContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d05f9",
  null
  
)

export default component.exports